(() => {
  'use strict';

  const KEY = '__DivettaMobileTabletRepairV1';
  window[KEY]?.destroy?.();

  const controller = new AbortController();
  const { signal } = controller;
  const reviewObservers = new Map();
  function visible(element) {
    if (!(element instanceof HTMLElement) || !element.isConnected || element.hidden) return false;
    const style = getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && Number.parseFloat(style.opacity || '1') > 0.02 && rect.width > 1 && rect.height > 1;
  }

  function numericReviewCount(root) {
    const candidates = [
      root.querySelector('#judgeme_product_reviews'),
      root.querySelector('.jdgm-rev-widg')
    ].filter(Boolean);
    const names = ['data-number-of-reviews', 'data-review-count', 'data-reviews-count', 'data-count'];
    for (const element of candidates) {
      for (const name of names) {
        const raw = element.getAttribute?.(name);
        if (raw == null || raw === '') continue;
        const value = Number.parseInt(raw, 10);
        if (Number.isFinite(value)) return value;
      }
    }
    return null;
  }

  function syncReviewState(root) {
    if (!(root instanceof HTMLElement) || !root.isConnected) return;
    const widget = root.querySelector('#judgeme_product_reviews');
    if (!(widget instanceof HTMLElement)) {
      root.dataset.ldJdgmState = 'waiting';
      return;
    }

    const reviews = widget.querySelectorAll('.jdgm-rev, [data-review-id]').length;
    const declaredCount = numericReviewCount(root);
    const providerSurface = root.querySelector('.jdgm-rev-widg, .jdgm-widget-actions-wrapper, .jdgm-rev-widg__body');

    if (reviews > 0 || (declaredCount !== null && declaredCount > 0)) {
      root.dataset.ldJdgmState = 'ready';
    } else if (declaredCount === 0 || visible(providerSurface)) {
      root.dataset.ldJdgmState = 'zero';
    } else {
      root.dataset.ldJdgmState = 'waiting';
    }
  }

  function mountReview(root) {
    if (!(root instanceof HTMLElement) || reviewObservers.has(root)) return;
    syncReviewState(root);
    const observer = new MutationObserver(() => syncReviewState(root));
    observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'hidden', 'style', 'data-number-of-reviews', 'data-review-count', 'data-reviews-count', 'data-count'] });
    reviewObservers.set(root, observer);
  }

  function unmountReview(root) {
    reviewObservers.get(root)?.disconnect();
    reviewObservers.delete(root);
  }

  function scan(scope = document) {
    const reviewRoots = [];
    if (scope.matches?.('.ld-judgeme-reviews')) reviewRoots.push(scope);
    scope.querySelectorAll?.('.ld-judgeme-reviews').forEach((root) => reviewRoots.push(root));
    reviewRoots.forEach(mountReview);

    Array.from(reviewObservers.keys()).forEach((root) => {
      if (!root.isConnected) unmountReview(root);
    });
  }

  document.addEventListener('shopify:section:load', (event) => scan(event.target), { signal });
  document.addEventListener('shopify:section:unload', (event) => {
    Array.from(reviewObservers.keys()).forEach((root) => {
      if (event.target === root || event.target.contains?.(root)) unmountReview(root);
    });
  }, { signal });
  window.addEventListener('pageshow', () => scan(document), { signal });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan(document), { once: true, signal });
  } else {
    scan(document);
  }

  window[KEY] = Object.freeze({
    scan,
    destroy() {
      controller.abort();
      Array.from(reviewObservers.keys()).forEach(unmountReview);
      delete window[KEY];
    }
  });
})();
